import { type FormEventHandler, useCallback, useContext } from 'react';

import { getConfig } from '../../../config/envConfig';
import { ReactConsentContext } from '../../Flow/ConsentContextProvider';

const ROVO_SUCCESS_REDIRECT_DELAY_MS = 5_000;
const ROVO_SUCCESS_PATH = '/security/dagterminal';

export function isRovoDesktopCallback(callback?: string): boolean {
  if (!callback) return false;

  try {
    return new URL(callback).protocol === 'rovo-desktop:';
  } catch {
    return false;
  }
}

export const useRovoSuccessRedirect = (): FormEventHandler<HTMLFormElement> => {
  const consentContext = useContext(ReactConsentContext);
  const callback = consentContext?.token?.redirectUrl?.callback;

  return useCallback(
    (event) => {
      const submitter = (event.nativeEvent as SubmitEvent)
        .submitter as HTMLButtonElement | null;
      const callbackMatched = isRovoDesktopCallback(callback);
      const accepted = submitter?.value === 'accept';
      const redirectScheduled = callbackMatched && accepted;
      const destination = `${getConfig().identity.baseUrl}${ROVO_SUCCESS_PATH}`;

      if (!redirectScheduled) return;

      // Do not prevent the POST: its redirect launches the native Rovo app.
      setTimeout(
        () => window.location.assign(destination),
        ROVO_SUCCESS_REDIRECT_DELAY_MS,
      );
    },
    [callback],
  );
};
